import React, { Component } from "react";
import { apiService } from "../../../../base/utils/service";
import { Nav, Tab } from "react-bootstrap";
import { MdClose } from "react-icons/md";
import InfiniteScroll from "react-infinite-scroll-component";
import Empty from "../../../../base/features/blocks/Empty";
import Spinner from "../../../../base/features/micro/Spinner";
import Image from "../../../../base/features/micro/Image";
import { FiChevronRight } from "react-icons/fi";
import OrderBlock from "../../../../base/features/blocks/OrderBlock";
import Comment from "../../../shop/comment/Comment";
import { HiLocationMarker } from "react-icons/hi";
import { Link } from "react-router-dom";

class CustomerProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: null,
      carts: null,
      shops: null,
      defaultActiveKey: "carts",
      commentsSearchKey: "",
      cartsSearchKey: "",
      shopsSearchKey: "",
      hasMoreComments: false,
      hasMoreShops: false,
      nextComments: "",
      nextShops: "",
      hasMoreCarts: false,
      nextCarts: "",
      shopUid: window.location.pathname.split("/")[2],
      customerId: window.location.pathname.split("/")[4],
      user: null,
    };
  }
  componentDidMount() {
    this.getUser();
    this.getCarts();
    this.getComments();
    this.getShops();
  }
  getUser() {
    apiService(`v1/users/info/${this.state.customerId}`, "get").then((data) => {
      if (data) {
        this.setState({ user: data });
      }
    });
  }
  getComments() {
    let q = this.state.commentsSearchKey;
    apiService(
      `v1/socials/comments?user=${this.state.customerId}&location=${this.state.shopUid}&q=${q}`
    ).then((data) => {
      if (data) {
        if (this.state.commentsSearchKey === q) {
          this.setState({
            comments: data.results,
            hasMoreComments: data.next ? true : false,
            nextComments: data.next,
          });
        }
      }
    });
  }
  getCarts() {
    let q = this.state.cartsSearchKey;
    apiService(
      `v1/shops/${this.state.shopUid}/orders?user=${this.state.customerId}&q=${q}`
    ).then((data) => {
      if (data) {
        if (this.state.cartsSearchKey === q) {
          this.setState({
            carts: data.results,
            hasMoreCarts: data.next ? true : false,
            nextCarts: data.next,
          });
        }
      }
    });
  }
  getShops() {
    let q = this.state.shopsSearchKey;
    apiService(
      `v1/contents/locations?user=${this.state.customerId}&q=${q}`
    ).then((data) => {
      if (data) {
        if (this.state.shopsSearchKey === q) {
          this.setState({
            shops: data.results,
            hasMoreShops: data.next ? true : false,
            nextShops: data.next,
          });
        }
      }
    });
  }
  fetchMoreComments() {
    apiService(this.state.nextComments, "get").then((data) => {
      if (data) {
        var newComments = this.state.comments;
        newComments = newComments.concat(data.results);
        this.setState({
          comments: newComments,
          hasMoreComments: data.next ? true : false,
          nextComments: data.next,
        });
      }
    });
  }
  fetchMoreCarts() {
    apiService(this.state.nextCarts, "get").then((data) => {
      if (data) {
        var newCarts = this.state.carts;
        newCarts = newCarts.concat(data.results);
        this.setState({
          carts: newCarts,
          hasMoreCarts: data.next ? true : false,
          nextCarts: data.next,
        });
      }
    });
  }
  fetchMoreShops() {
    apiService(this.state.nextShops, "get").then((data) => {
      if (data) {
        var newShops = this.state.shops;
        newShops = newShops.concat(data.results);
        this.setState({
          shops: newShops,
          hasMoreShops: data.next ? true : false,
          nextShops: data.next,
        });
      }
    });
  }
  render() {
    return (
      <div className="container-fluid px-0">
        <Tab.Container
          className="border-0 w-100"
          activeKey={this.state.defaultActiveKey}
          onSelect={(i) => this.setState({ defaultActiveKey: i })}
          defaultActiveKey={this.state.defaultActiveKey}
          id="tab-example4"
        >
          <div
            className="row mx-0 bg-white position-fixed shadow-sm"
            style={{ top: "0", left: "0", right: "0", zIndex: "9999999" }}
          >
            <div className="row mx-0 px-4 py-2-3">
              <div className="col-auto px-1">
                <FiChevronRight
                  size={28}
                  className="ms-3"
                  onClick={() => window.history.back()}
                />
                <Image
                  imageHeight={"60"}
                  imageWidth={"60"}
                  extraClassName={"p-0 img-contain"}
                  imgClassName={"rounded-circle img-cover"}
                  isProfile={true}
                  imageUri={this.state.user && this.state.user.profile.image}
                />
              </div>
              <div className="col px-1 align-self-center">
                <h1 className="fw-bold fs-5 mb-0">
                  {this.state.user && this.state.user.profile.name}
                </h1>
              </div>
            </div>

            <div className="col-4 text-center px-0">
              <Nav.Link
                className={
                  "p-3 fw-bolder fs-6 " +
                  (this.state.defaultActiveKey === "carts"
                    ? "border-main border-3 color-main border-top-0 border-start-0 border-end-0"
                    : "text-muted")
                }
                eventKey="carts"
              >
                سفارشات
              </Nav.Link>
            </div>

            <div className="col-4 text-center px-0">
              <Nav.Link
                className={
                  "p-3 fw-bolder fs-6 " +
                  (this.state.defaultActiveKey === "comments"
                    ? "border-main border-3 color-main border-top-0 border-start-0 border-end-0"
                    : "text-muted")
                }
                eventKey="comments"
              >
                نظرات
              </Nav.Link>
            </div>

            <div className="col-4 text-center px-0">
              <Nav.Link
                className={
                  "p-3 fw-bolder fs-6 " +
                  (this.state.defaultActiveKey === "shops"
                    ? "border-main border-3 color-main border-top-0 border-start-0 border-end-0"
                    : "text-muted")
                }
                eventKey="shops"
              >
                فروشگاه ها
              </Nav.Link>
            </div>
          </div>

          <div className="row mx-0" style={{ marginTop: "150px" }}>
            <div className="col-12 px-0">
              <Tab.Content>
                <Tab.Pane eventKey="carts">
                  {this.state.carts ? (
                    <section className="px-0">
                      <div className="row mx-0 px-4">
                        <div className="col-12 px-0 py-3 text-center position-relative">
                          <input
                            type="text"
                            value={this.state.cartsSearchKey}
                            onChange={(e) =>
                              this.setState(
                                { cartsSearchKey: e.target.value },
                                () => {
                                  this.getCarts();
                                }
                              )
                            }
                            className="form-control px-3 py-2 rounded14 w-100"
                            style={{ height: "44px" }}
                            placeholder="جستجو کنید"
                          />
                          {this.state.cartsSearchKey.length !== 0 && (
                            <MdClose
                              size={26}
                              style={{ left: "12px", top: "0", bottom: "0" }}
                              className="position-absolute my-auto"
                              onClick={() =>
                                this.setState({ cartsSearchKey: "" }, () => {
                                  this.getCarts();
                                })
                              }
                            />
                          )}
                        </div>
                      </div>
                      <InfiniteScroll
                        dataLength={this.state.carts.length}
                        next={() => this.fetchMoreCarts()}
                        hasMore={this.state.hasMoreCarts}
                        className="row mx-0 px-4"
                        loader={<Spinner />}
                      >
                        {this.state.carts.length === 0 && (
                          <Empty text={"سفارشی یافت نشد."} />
                        )}
                        {this.state.carts.map((cart, c) => (
                          <OrderBlock order={cart} />
                        ))}
                      </InfiniteScroll>
                    </section>
                  ) : (
                    <Spinner />
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="comments">
                  {this.state.comments ? (
                    <section>
                      <div className="row mx-0 px-4">
                        <div className="col-12 px-0 py-3 text-center position-relative">
                          <input
                            type="text"
                            value={this.state.commentsSearchKey}
                            onChange={(e) =>
                              this.setState(
                                { commentsSearchKey: e.target.value },
                                () => {
                                  this.getComments();
                                }
                              )
                            }
                            className="form-control px-3 py-2 rounded14 w-100"
                            style={{ height: "44px" }}
                            placeholder="جستجو کنید"
                          />
                          {this.state.commentsSearchKey.length !== 0 && (
                            <MdClose
                              size={26}
                              style={{ left: "12px", top: "0", bottom: "0" }}
                              className="position-absolute my-auto"
                              onClick={() =>
                                this.setState({ commentsSearchKey: "" }, () => {
                                  this.getComments();
                                })
                              }
                            />
                          )}
                        </div>
                      </div>
                      <InfiniteScroll
                        dataLength={this.state.comments.length}
                        next={() => this.fetchMoreComments()}
                        hasMore={this.state.hasMoreComments}
                        className="row mx-0 px-0"
                        loader={<Spinner />}
                      >
                        {this.state.comments.length === 0 ? (
                          <Empty text={"نظری ثبت نشده."} />
                        ) : (
                          this.state.comments.map((comment, c) => (
                            <div key={c} className="col-12 px-0 border-bottom">
                              <Comment
                                comment={comment}
                                // management={true}
                                key={c}
                                get_comments={() => this.getComments()}
                              />
                            </div>
                          ))
                        )}
                      </InfiniteScroll>
                    </section>
                  ) : (
                    <Spinner />
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="shops">
                  {this.state.shops ? (
                    <section>
                      <div className="row mx-0 px-4">
                        <div className="col-12 px-0 py-3 text-center position-relative">
                          <input
                            type="text"
                            value={this.state.shopsSearchKey}
                            onChange={(e) =>
                              this.setState(
                                { shopsSearchKey: e.target.value },
                                () => {
                                  this.getShops();
                                }
                              )
                            }
                            className="form-control px-3 py-2 rounded14 w-100"
                            style={{ height: "44px" }}
                            placeholder="جستجو کنید"
                          />
                          {this.state.shopsSearchKey.length !== 0 && (
                            <MdClose
                              size={26}
                              style={{ left: "12px", top: "0", bottom: "0" }}
                              className="position-absolute my-auto"
                              onClick={() =>
                                this.setState({ shopsSearchKey: "" }, () => {
                                  this.getShops();
                                })
                              }
                            />
                          )}
                        </div>
                      </div>
                      <InfiniteScroll
                        dataLength={this.state.shops.length}
                        next={() => this.fetchMoreShops()}
                        hasMore={this.state.hasMoreShops}
                        className="row mx-0 px-0"
                        loader={<Spinner />}
                      >
                        {this.state.shops.length === 0 ? (
                          <Empty text={"فروشگاهی ثبت نشده."} />
                        ) : (
                          this.state.shops.map((shop, s) => (
                            <div key={s} className="col-12 px-4 py-3">
                              <Link to={`/${shop.uid}`}>
                                <div className="row mx-0">
                                  <div className="col-auto align-self-center">
                                    <HiLocationMarker size={28} />
                                  </div>
                                  <div className="col px-1">
                                    <p className="fw-bold mb-0">
                                      {shop.title_fa}
                                    </p>
                                    <p className="fw-bold small text-muted mb-0">
                                      {shop.sub_title_fa}
                                    </p>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          ))
                        )}
                      </InfiniteScroll>
                    </section>
                  ) : (
                    <Spinner />
                  )}
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    );
  }
}

export default CustomerProfile;
